import { TFunction } from 'react-i18next';
import { CardsListFilters } from '../contexts/Card';
import { CardStatuses } from '../types';
import { mappingCardStatusesValues } from './mappingCardStatusesValues';

const addTargetFilterParams = (filters: CardsListFilters, t: TFunction, isCardHolderDashboard?: boolean) =>
  Object.assign(
    {},
    filters.cardholderIdentification && {
      partyIdentifications: [
        {
          type: 'CoreBankingIdentifier',
          identifier: {
            value: filters.cardholderIdentification?.value,
            issuingAuthority: 'Profits',
          },
        },
      ],
    },
    {
      paymentCardStatuses: filters.paymentCardStatuses
        ? mappingCardStatusesValues(t, filters?.paymentCardStatuses)
        : isCardHolderDashboard
        ? [
            CardStatuses.Active,
            CardStatuses.Blocked,
            CardStatuses.In_Progress,
            CardStatuses.Inactive,
            CardStatuses.Pin_Tries_Exceeded,
          ]
        : [
            CardStatuses.Active,
            CardStatuses.Blocked,
            CardStatuses.In_Progress,
            CardStatuses.Inactive,
            CardStatuses.Pin_Tries_Exceeded,
          ],
    },
    filters.cardNumberSuffix && { cardNumberSuffix: filters.cardNumberSuffix },
  );
export { addTargetFilterParams };
